import { useGLTF, RoundedBox, Text } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { COLORS } from "../../constants/colors";
import PointerShadow from "../pointers/PointerShadow.jsx";
import { MODELS } from "../loader/models.js";

const Plant = ({ position = [0, 0, 0] }) => {
  const { scene } = useGLTF(MODELS.PLANT);

  return (
    <group position={position}>
      <Text
        fontSize={0.9}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[3, -0.99, 10]}
      >
        #PlantsGrower
      </Text>
      <primitive scale={1.5} position-y={-0.5} object={scene} />
      <PointerShadow width={11} height={11} opacity={0.5} softness={0.8} />
      <RigidBody type="fixed" colliders="cuboid" ccd={false}>
        <RoundedBox args={[3, 1, 3]} radius={0.01} position-y={-0.99}>
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </RoundedBox>
      </RigidBody>
    </group>
  );
};

export default Plant;
